import React from 'react';

import { ChatBubbleLeftRightIcon } from '@heroicons/react/24/outline';
import { Helmet } from 'react-helmet-async';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import PageHeader from '../../Layout/PageHeader';
import Button from '../../UI/Buttons/Button';
import FAQ from './FAQ';
import { LineChatIcon } from '../../UI/Icons/LineChatIcon';
import { openZendesk } from '../../Zendesk';
import { GTagEvents, triggerGTag } from '@/lib/gTagManager';
import { selectLocale } from '@/store/selectors/commonSelectors';
import { useModal } from '@/features/modal/useModal';
import { MODALS } from '@/features/modal/types';

function Help() {
  const locale = useSelector(selectLocale);
  const intl = useIntl();
  const { openModal } = useModal();

  const handleOpenLineChat = () => {
    openModal(MODALS.LINE_CHAT);
  };

  return (
    <>
      <Helmet>
        <title>LuckyDays - {intl.formatMessage({ id: 'help.header' })}</title>
      </Helmet>
      <PageHeader>
        <h1>{intl.formatMessage({ id: 'help.header' })}</h1>
        <p>{intl.formatMessage({ id: 'help.subHeader' })}</p>
        <div className="flex items-center justify-center gap-4 [&>button]:!mx-0">
          <Button
            light
            iconleft
            onClick={() => {
              openZendesk();
              triggerGTag(GTagEvents.open_support);
            }}
          >
            <ChatBubbleLeftRightIcon /> {intl.formatMessage({ id: 'help.contactButton' })}
          </Button>
          {locale === 'th' && (
            <div className="[&>button]:h-[56px] [&>button]:py-0">
              <Button light iconleft onClick={handleOpenLineChat}>
                <LineChatIcon /> {intl.formatMessage({ id: 'help.lineChatButton' })}
              </Button>
            </div>
          )}
        </div>
      </PageHeader>
      <FAQ />
    </>
  );
}

export default Help;
